import React, { Component, PropTypes } from 'react';
import { formatNumber, DateFormatter } from '../../utils/date';
import tryActivateElem from '../timeline/scrollActivate';
import { Link } from 'react-router';
import { jobsRoute} from '../../routes/index';
import Clamp from 'react-clamp';

import Image from '../image/image';

import css from './timelineJobs.scss';

export default class TimelineJobsElement extends Component {
	static propTypes = {
		item: PropTypes.object.isRequired,
		browser: PropTypes.object.isRequired,
		className: PropTypes.string,
		sortDate: PropTypes.string.isRequired,
		same: PropTypes.string.isRequired,
	};
	static defaultProps = {
		points: 0,
		className: '',
	};

	constructor(props) {
		super(props);

		this.boundingRect = false;

		//this.testbg = `rgb(${Math.floor(Math.random() * 255) + 1}, ${Math.floor(Math.random() * 255) + 1}, ${Math.floor(Math.random() * 255) + 1})`;
		this.state = {
			clamped: false,
		};

		this.tryActivateElem = (scrollTop) => {
			function hasClass(element, cls) {
				return (' ' + element.className + ' ').indexOf(' ' + cls + ' ') > -1;
			}

			this.boundingRect = this.refs.timelineJobs.getBoundingClientRect();
			let shouldActivate = (this.boundingRect.top <= this.props.browser.window.height + 150);

			if (shouldActivate) {
				if (!hasClass(this.refs.timelineElement, 'active')) {
					this.refs.timelineElement.className += ' active';
					this.props.browser.scroll.deregister(this.tryActivateElem);
				}
			}

			return shouldActivate;
		};
	}

	componentDidMount() {
		this.tryActivateElem = tryActivateElem(this.getElement.bind(this), this.props.browser);
		if (!this.tryActivateElem()) {
			this.props.browser.scroll.register(this.tryActivateElem);
		}

		if (!this.state.clamped) {
			this.setState({
				clamped: true,
			});
		}
	}

	componentWillUnmount() {
		this.props.browser.scroll.deregister(this.tryActivateElem);
	}

	shouldComponentUpdate(nProps, nState) {
		return (
			nState !== this.state ||	
			nProps.browser.window.width !== this.props.browser.window.width ||
			nProps.createdDate !== this.props.createdDate ||
			nProps.title !== this.props.title ||
			nProps.className !== this.props.className ||
			nProps.browser.window.width !== this.props.browser.window.width
		);
	}

	componentDidUpdate() {
		//this.boundingRect = this.refs.timelineCase.getBoundingClientRect();
	}

	render() {
		//let { title, categories, profiles, points, createdDate } = this.props.item;
		let createdDate = new DateFormatter(this.props.sortDate);
		let jobs = this.props.item.items;

		let month = createdDate.month;

		if (this.props.browser.window.width < 1200) {
			month = createdDate.monthShort;
		}

		return (
			<li className={'timeline__element span6 span12-mobile ' + this.props.className + ' ' + this.props.same} ref='timelineElement'>
				<time className='timeline-jobs__date span1'>
					<span className='timeline-jobs__date--day'>{createdDate.date}</span>
					<span className='timeline-jobs__date--month'>{month}</span>
				</time>
				<div className='timeline-jobs__filler--before span2'></div>
				<ul className='timeline-jobs span4 span6-tablet span12-mobile' ref='timelineJobs'>
					<li className='timeline-jobs__description'>
						<span className='timeline-jobs__description--title'>Jobs</span>
						<Link to={jobsRoute()} className='timeline-jobs__description--link'>All Jobs</Link>
					</li>
					{jobs.map((item, i) => this.renderJob(item, i))}
				</ul>
				<div className='timeline-jobs__filler--after span2'></div>
			</li>
		);
	}

	renderJob(job, i) {
		let uid = job.uid || ('job' + job.id);
		let profile = '';

		if (job.item.profiles) {
			profile = job.item.profiles.name + ', ';
		}

		let string = profile + job.item.city + ', ' + job.item.country;

		return (
			<li key={uid}>
				<Link to={jobsRoute(job.item.slug)} className='timeline-jobs__job span4 span6-tablet span12-mobile'>
					{this.props.browser.window.width < 720 && (
					<h3><Clamp clamp={1} ellipsis="…">{job.item.title}</Clamp></h3>
					) || (
					<h3>{job.item.title}</h3>
					)}
					<Clamp className="timeline-jobs__job__trunc" clamp={1} ellipsis="…">{string}</Clamp>
				</Link>
			</li>
		);
	}

	getCategoryName(categories) {
		let cat = '';
		if (categories && typeof categories === 'object' && categories.length) {
			cat = categories.slice(0, 1).map((item) => {
				return item.name;
			});
		}

		return cat;
	}

	getElement() {
		return this.refs.timelineElement;
	}
}



/** WEBPACK FOOTER **
 ** ./frontend/components/timelinejobs/timelineJobs.js
 **/